import { render, staticRenderFns } from "./UnitAddNew.vue?vue&type=template&id=ba219bc8"
import script from "./UnitAddNew.vue?vue&type=script&lang=js"
export * from "./UnitAddNew.vue?vue&type=script&lang=js"
import style0 from "./UnitAddNew.vue?vue&type=style&index=0&id=ba219bc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports